import React, { FC } from 'react'
import { BaseFacetProps } from '../types'
import colorMatrix from 'lib/algolia/v2/colors'
import styles from '../Facets.module.scss'
import Tick from 'svg/tick.svg'
import NoColorIcon from 'svg/SA/no-color-round.svg'
import classNames from 'classnames'
import ColorFacetConnector, { ColorFacetConnectorProps } from 'connectors/Facets/ColorFacet'
import { FacetsConnector, FacetsConnectorProps } from 'connectors/Facets'
import { updateClientSideUrl } from '../helpers/url'

type ColorFacetProps = BaseFacetProps & FacetsConnectorProps

type FacetColorProps = ColorFacetConnectorProps &
  Pick<FacetsConnectorProps, 'getHref' | 'updateFacetValues'> & {
    baseUrl: string
    nextAppRoute: string
    color: string
  }

const FacetColorBase: FC<FacetColorProps> = ({
  baseUrl,
  nextAppRoute,
  color,
  isSelected,
  isAvailable,
  getHref,
  updateFacetValues,
}) => {
  const href = getHref({
    color: updateFacetValues('color', color),
    page: '', // Reset Page
  })
  const newUrlPath = `${baseUrl}${href}`

  return isAvailable ? (
    <div
      className={classNames(styles.colorDesktop, styles.colorDesktopAvailable)}
      data-gtm-event='filter'
      data-gtm-info={`Color - ${color}`}
      onClick={(ev) => {
        ev.preventDefault()
        updateClientSideUrl(newUrlPath, nextAppRoute)
      }}
      style={{ '--color-value': color } as React.CSSProperties}
    >
      <div
        className={classNames(styles.colorSected, {
          [styles.colorSectedVisible]: isSelected,
        })}
      >
        <Tick />
      </div>
    </div>
  ) : (
    <NoColorIcon className={styles.noColorIcon} />
  )
}
const FacetColor = ColorFacetConnector(FacetColorBase)

const ColorFacet: FC<ColorFacetProps> = ({
  baseUrl,
  nextAppRoute,
  allSelectedFacets,
  getHref,
  updateFacetValues,
}) => {
  const isColorFacetSelected = allSelectedFacets.some(
    (selectedFacet) => selectedFacet.facetName === 'color'
  )

  const resetColorFilter = () => {
    const href = getHref({
      color: [],
      page: '', // Reset Page
    })
    updateClientSideUrl(href, nextAppRoute)
  }

  return (
    <div className={styles.colorFacetContainer}>
      <div className={styles.colorFacetRow}>
        {colorMatrix.map((matrix, key) => (
          <div className={styles.colorFacetColumn} key={key}>
            {matrix.map((color, key2) => (
              <FacetColor
                getHref={getHref}
                updateFacetValues={updateFacetValues}
                baseUrl={baseUrl}
                nextAppRoute={nextAppRoute}
                {...{
                  color,
                  key: key2,
                }}
              />
            ))}
          </div>
        ))}
      </div>
      {isColorFacetSelected && (
        <button className={styles.removeColorFilterButton} onClick={resetColorFilter}>
          Remove Color Filter
        </button>
      )}
    </div>
  )
}

export default FacetsConnector(ColorFacet)
